import { TRACKING_EVENT, trackEvent } from '@zooplus/tracker-listener';

const trackCustomer = (sid, site, page, deviceType, customer, metric) => {
    try {
        let trackingData = {
            event: TRACKING_EVENT.EXPERIMENT,
            page: page.name,
            detail: {
                sid: sid,
                domain: site.domain,
                siteId: site.id,
                locale: site.locale,
                currencyCode: site.currencyCode,
                pageLocation: page.pageLocation,
                platform: deviceType,
                customer: {
                    id: customer.id,
                    orderCount: 1,
                    guest: customer.isGuest
                },
                experiments: [
                    {
                        id: 'shipping_fee_a_b_test',
                        tool: 'OPTIMIZELY',
                        value: metric
                    }
                ]
            }
        };
        trackEvent(trackingData);
    }
    catch (e) {
        console.error('adobe event error ...', e);
    }
};

export { trackCustomer };
//# sourceMappingURL=eventTracker.js.map
